<template>
  <div id="page">
    <b-container class="text-left">
      <div style="margin-top: 8px">
        <div>
          <label>订单状态：</label><b><span>等待申请人付款</span></b>
        </div>
        <div>
          <label>订单编号：</label
          ><b
            ><span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderNo
            }}</span></b
          >
        </div>
        <div>
          <label
            >您的图片已提交，请在24小时内完成支付，超时订单将自动取消</label
          >
        </div>
      </div>

      <div style="margin-top: 8px">
        <div>
          <b><label>付款商品</label></b>
          <div>
            <label>卡片定制服务费:</label
            ><span>{{
              orderInfoObj == null ? "" : orderInfoObj.price / 100
            }}</span>
          </div>
        </div>

        <div style="margin-top: 8px">
          <b><label>结算</label></b>
          <div>
            <label>应付金额：</label
            ><span>{{
              orderInfoObj == null ? "" : orderInfoObj.price / 100
            }}</span>
          </div>
          <div>
            <label>下单时间：</label
            ><span>{{
              orderInfoObj == null ? "" : orderInfoObj.orderDateTime
            }}</span>
          </div>
        </div>
        <div style="margin-top: 8px">
          <b><label>温馨提示</label></b>
          <div>
            <span>我们将在20个工作日左右为您寄送卡片，请注意查收</span>
          </div>
        </div>

        <div align="center" class="actionArea">
          <b-button block variant="danger" style="width: 80%" @click="wxPay()"
            >微信支付</b-button
          >
          <b-button
            block
            variant="primary"
            style="width: 80%"
            @click="replaceCardface()"
            >更改图片</b-button
          >
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "OrderPay",
  data() {
    return {
      orderInfoObj: null,
      appid: "",
      code: "",
    };
  },
  methods: {
    toOrderResult: function () {
      this.$router.replace({
        name: "OrderResult",
        params: {
          orderNo: this.orderInfoObj.orderNo,
        },
      });
    },

    wxPay: function () {
      this.unifyOrder();
    },
    replaceCardface: function () {
      var param = {
        isModify: 1,
        orderNo: this.orderInfoObj == null ? "" : this.orderInfoObj.orderNo,
        backgroundColor:
          this.orderInfoObj == null ? "" : this.orderInfoObj.backgroundColor,
      };

      var selectParam = JSON.stringify(param);
      console.log("selectParam:" + selectParam);
      this.$router.push({
        name: "SelectCardface",
        params: {
          selectParam: selectParam,
        },
      });
    },
    starToPay: function (payargs) {
      console.log("======starToPay======");
      var that = this;
      wx.chooseWXPay({
        timestamp: payargs.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payargs.nonceStr, // 支付签名随机串，不长于 32 位
        package: payargs.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        signType: payargs.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payargs.sign, // 支付签名
        success: function (res) {
          // 支付成功后的回调函数
          console.log("支付成功" + res);
          that.toOrderResult();
        },
        // 支付取消回调函数
        cencel: function (res) {
          console.log(res);
        },
        // 支付失败回调函数
        fail: function (res) {
          console.log(res);
        },
      });
    },
    wxJsSdk: function () {
      var that = this;
      var url = window.location.href.split("#")[0];
      var formData = new FormData();
      formData.append("shareUrl", url);
      axios({
        method: "post",
        url: "https://cp.hengbao.net.cn/pay/order/wx/initWXJSSDKConfigInfo",
        data: formData,
      })
        .then(function (response) {
          var data = response.data;
          that.appid = data.appid;
          console.log(data.appid);
          console.log(response.data);
          console.log(response.status);
          console.log(response.statusText);
          console.log(response.headers);
          console.log(response.config);

          /* {
              signature: "1ba9d96ab3b38bb34037b46d5714d61b659d3031",
              appid: "wxecacb5516c17832b",
              jsapi_ticket: "kgt8ON7yVITDhtdwci0qeR5ZO1LunrcgBtLGj8xD8npFwV-6wRlIWdgjZMmuTynPLmFHHz7E30LFBGwzmBtLOg",
              nonceStr: "6024281b-1600-4960-81b6-87876c9203b4",
              timestamp: "1589963929"
            } */

          wx.config({
            debug: false,
            appId: data.appid,
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ["chooseWXPay"],
          });

          wx.ready(function () {
            that.checkOpenid();
          });
          wx.error(function (res) {
            console.log(res);
          });
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    checkOpenid: function () {
      console.log("=========checkOpenid=========");
      var openid = sessionStorage.getItem("openid");
      var code = this.getUrlParam("code"); // 截取code
      this.code = code;

      console.log("openid:" + openid);
      console.log("code:" + code);
      console.log("code is empty + " + (code == ""));

      if (openid == undefined) {
        if (this.code == "") {
          this.getCode();
        } else {
          var myObj = {
            code: this.code,
          };

          axios
            .post(
              "https://cp.hengbao.net.cn/pay/order/wx/getJSAPIOpenid",
              myObj
            )
            .then(function (response) {
              /* {
                  access_token: "33_ydBrI6lMSAVfEZWX5Q7Kw30jbuTiTCOrca_hPDU3g53tE7drWJRnOteLtPrmtKcFz3gBBL1RhpgefRrBKWQNug"
                  expires_in: 7200
                  openid: "oVdoHv2bVEk5wtyyHAf_Y6cjZZPw"
                  refresh_token: "33_0iS-3XElEHIpcZhmcaaPZl8xTkXnY1O1Zv6NTndAth9ro_srWEeuInDeoNcnR1F70fgCgENZmAcJt1o7YmVi3A"
                  scope: "snsapi_base"
                } */
              console.log(response);
              var data = response.data;
              var openid = data.openid;
              sessionStorage.setItem("openid", openid);
            })
            .catch(function (error) {
              console.log(error);
            });
        }
      } else {
      }
    },
    getCode: function () {
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?";
      var appid = "appid=" + encodeURIComponent(this.appid);
      var redirect_uri =
        "&redirect_uri=" + encodeURIComponent(window.location.href);
      var response_type = "&response_type=" + encodeURIComponent("code");
      //静默获取code
      var scope = "&scope=" + encodeURIComponent("snsapi_base");
      //需要用户授权获取code
      //var scope = "&scope=" + encodeURIComponent("snsapi_userinfo");
      var state = "&state=" + encodeURIComponent("123");
      var wechat_redirect = "#wechat_redirect";

      var targetUrl =
        url +
        appid +
        redirect_uri +
        response_type +
        scope +
        state +
        wechat_redirect;

      window.location.href = targetUrl;
    },
    getUrlParam: function (variable) {
      var query = window.location.search.substring(1);
      console.log("url search param:" + query);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return decodeURIComponent(pair[1]);
        }
      }
      return "";
    },
    unifyOrder: function () {
      var that = this;
      var openid = sessionStorage.getItem("openid");

      var myObj = {
        hbTradeType: 1,
        openid: openid,
        order_id: this.orderInfoObj.orderNo,
        total_fee: this.orderInfoObj.price,
        pay_source: this.orderInfoObj.projectName,
      };

      axios
        .post("https://cp.hengbao.net.cn/pay/order/wx/unifiedOrder", myObj)
        .then(function (response) {
          console.log(response);
          var data = response.data;
          if (data.code === 200) {
            var payargs = data.data;
            console.log(payargs);
            that.starToPay(payargs);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
  mounted: function () {
    /* {
         orderNo: '01248790113566597120',
         orderDateTime: '2020-05-22 09:39:22',
         price: 1,
         projectName: 'DIY',
         thumbnailFileUrl: ''
       } */
    var orderInfo = this.$route.params.orderInfo;
    if (orderInfo !== undefined) {
      this.orderInfoObj = JSON.parse(orderInfo);
      sessionStorage.setItem("orderInfo", orderInfo);
    } else {
      var orderInSession = sessionStorage.getItem("orderInfo");
      this.orderInfoObj = JSON.parse(orderInSession);
    }

    this.wxJsSdk();
  },
};
</script>

<style scoped>
.actionArea {
  margin-top: 32px;
  margin-bottom: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/OrderPay.vue